import { render, staticRenderFns } from "./EtapaClassificacao.vue?vue&type=template&id=004ebf4e"
import script from "./EtapaClassificacao.vue?vue&type=script&lang=js"
export * from "./EtapaClassificacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports